import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { setCanonical } from "../lib/seo";

const DEFAULT_TITLE = "SaaSRadarHub | Find Software Worth Using";
const PAGE_TITLES = {
  "/reviews": "Software Reviews",
  "/comparisons": "Software Comparisons",
  "/guides": "Software Buying Guides",
  "/categories": "Software Categories",
  "/about": "About Us",
  "/contact": "Contact Us",
  "/affiliate-disclosure": "Affiliate Disclosure",
  "/privacy": "Privacy Policy",
  "/terms": "Terms of Use",
  "/search": "Search",
};

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => {
    const page = PAGE_TITLES[pathname.replace(/\/+$/, "")];
    document.title = page ? `${page} | SaaSRadarHub` : DEFAULT_TITLE;
    setCanonical(pathname);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-paper overflow-x-clip">
      <Header />
      <main className="flex-1 bg-[linear-gradient(180deg,#E9E6DE_0px,#F1EFE9_520px)]" data-testid="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
